import Logout from './Logout';
import Route from './route';

export default {
  RenderProp: Logout,
  mainRoute: Route,
};
